import axios from 'axios'
import { apiURL } from '@/config'
import ImageTools from '@/components/Utils/resizeBeforeUpload'

const fotos = {
  namespaced: true,
  actions: {
    adicionarFoto ({ dispatch }, payload) {
      if (payload.fields.foto === null) {
        dispatch('utils/showSnackbar', {
          text: 'O campo foto é obrigatório.',
          type: 'error'
        }, { root: true })
        dispatch('utils/hideLoading', {}, { root: true })
        return Promise.resolve(false)
      }

      const filename = payload.fields['fotoFilename']

      return new Promise((resolve, reject) => {
        ImageTools.resize(payload.fields['foto'], {
          width: 1024,
          height: 1024
        }, (blob) => {
          const formData = new FormData()

          formData.append('foto', blob, filename)
          Object.keys(payload.fields).forEach((key) => {
            if (key !== 'foto' && key !== 'id') {
              formData.append(key, payload.fields[key])
            }
          })

          axios.post(`${apiURL}/fotos/${payload.fields.id}`, formData).then((response) => {
            resolve(response.data.data)
          }).catch(reject)
        })
      })
    }
  }
}

export default fotos



// WEBPACK FOOTER //
// ./src/vuex/modules/fotos.js